import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

// GlobalStyles.js
const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={{
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      '#root': {
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      },
      body: {
        fontFamily: 'Arial, sans-serif',
        overflow: 'hidden',
      },
      // Add this for better table rendering
      '.MuiTableCell-root': {
        padding: '8px 16px',
      }
    }}
  />
);

export default GlobalStyles;